import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=4683ad20&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683ad20",
  null
  
)

export default component.exports